up.compiler('[data-stop-event]', (element: HTMLElement) => {
  const type = element.getAttribute('data-stop-event')!

  element.addEventListener(type, (event: Event) => {
    event.preventDefault()
    event.stopPropagation()
  })
})
